import {HttpClient} from "../../service/httpClient/HttpClient";
import axios from "axios";

export class LocationService {
    constructor() {
        this.httpClient = new HttpClient({},"","https://management.dmmkr.ir/resources/")
    }

    getProvinces() {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `provinces`
            ).then(resolve).catch(reject)
        })
    }

    getCity(provinceId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `provinces/${provinceId}/cities`
            ).then(resolve).catch(reject)
        })
    }

}